var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96 8.8c-.325 2.854-.208 7.022 1.208 11.127 1.496 4.336 4.43 8.585 9.832 11.189 5.402-2.604 8.342-6.854 9.842-11.19 1.42-4.105 1.542-8.273 1.219-11.126H8.96ZM31.763 8H8.258C7.378 13.89 8.3 26.61 20 32c11.7-5.39 12.642-18.11 11.763-24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29V11h-8.98C10.594 21.286 16.83 27.286 20 29Z",
    fill: "currentColor"
  })));
};
export default SvgInsurance;